import Register from "@/pages/Register";

export default function Prepayments() {
  return <Register lockedType="PREPAYMENT" />;
}
